module.exports = __webpack_public_path__ + "img/tearmsandconditions.cca1306b.svg";